import { Box, keychaine } from '@chaine/keychaine';
import React, { useEffect, useState } from 'react';
import { Marker as ReactMapGLMarker } from 'react-map-gl';
import { renderTrackingLocationMarkerPopup } from '.';
const CurrentLocationMarker = React.memo((props) => {
    const { color, location, locationSourceMetadata, sequence, source, preventPopupsOnHover = false } = props;
    const [tick, setTick] = useState(0);
    const [isHovered, setIsHovered] = useState(false);
    const handleMouseEnter = () => setIsHovered(true);
    const handleMouseLeave = () => setIsHovered(false);
    const onHandleMouseEnter = (event) => {
        event.preventDefault();
        handleMouseEnter();
    };
    const onHandleMouseLeave = (event) => {
        event.preventDefault();
        handleMouseLeave();
    };
    useEffect(() => {
        let animationFrameID = 0;
        const ticks = () => {
            setTick(performance.now());
            animationFrameID = requestAnimationFrame(ticks);
        };
        ticks();
        return () => {
            cancelAnimationFrame(animationFrameID);
        };
    }, []);
    if (!location?.coordinates?.latitude || !location?.coordinates?.longitude) {
        return React.createElement(keychaine.span, null);
    }
    const t = (tick % 1000) / 1000;
    const outerScale = 0.7 * t + 0.3;
    const outerOpacity = 1 - t;
    return (React.createElement(React.Fragment, null,
        isHovered &&
            !preventPopupsOnHover &&
            renderTrackingLocationMarkerPopup({ location, locationSourceMetadata, sequence, source }),
        React.createElement(ReactMapGLMarker, { key: 'current-location-marker', latitude: location.coordinates.latitude, longitude: location.coordinates.longitude },
            React.createElement(keychaine.span, { onMouseEnter: onHandleMouseEnter, onMouseLeave: onHandleMouseLeave, "aria-label": "current-location-marker" },
                React.createElement(Box, { position: "relative", w: "12", h: "12", key: color },
                    React.createElement(Box, { w: "4", h: "4", borderRadius: "50%", bg: location.locationInfo.isMockLocation ? 'red.500' : color, color: location.locationInfo.isMockLocation ? 'red.500' : color, opacity: 0.85, position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }),
                    React.createElement(Box, { w: "100%", h: "100%", borderRadius: "50%", bg: location.locationInfo.isMockLocation ? 'red.500' : color, opacity: outerOpacity, position: "absolute", top: "50%", left: "50%", transform: `translate(-50%, -50%) scale(${outerScale})` }))))));
});
CurrentLocationMarker.displayName = 'CurrentLocationMarker';
export { CurrentLocationMarker };
